// Estados e cidades por país: arquivos estáticos do projeto countries-states-cities-database
// (ODbL-1.0, https://github.com/dr5hn/countries-states-cities-database), servidos pelo jsDelivr
// na versão fixada do pacote @countrystatecity/countries-browser.
const BASE_URL =
  'https://cdn.jsdelivr.net/npm/@countrystatecity/countries-browser@2.0.0/dist/data';

const cache = new Map();

// Um país sem arquivo (404) ou uma falha de rede viram lista vazia, e o formulário cai para texto livre.
// Só a resposta definitiva (inclusive o 404) fica no cache; falha de rede pode ser tentada de novo.
const load = path => {
  if (!cache.has(path)) {
    cache.set(
      path,
      fetch(`${BASE_URL}/${path}`)
        .then(response => (response.ok ? response.json() : []))
        .catch(() => {
          cache.delete(path);
          return [];
        })
    );
  }
  return cache.get(path);
};

const byLabel = (a, b) => a.label.localeCompare(b.label);

// value é a sigla em minúsculas (formato que a Meta recebe: "sp", "ca").
export const getStates = async countryCode => {
  const states = await load(`states/${countryCode.toUpperCase()}.json`);
  return states
    .map(({ name, iso2 }) => ({ label: name, value: iso2.toLowerCase() }))
    .sort(byLabel);
};

export const getCities = async (countryCode, stateCode) => {
  const cities = await load(
    `cities/${countryCode.toUpperCase()}-${stateCode.toUpperCase()}.json`
  );
  return [...new Set(cities.map(({ name }) => name))]
    .map(name => ({ label: name, value: name }))
    .sort(byLabel);
};
